import { jsx, Fragment } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * The Portal component renders it's children at the end of `document.body` by default.
 * Portals are used to elevate components to the highest order tooltips, modals, and popovers.
 */ const Portal = ({ children })=>{
    const [portalWrapper, setPortalWrapper] = useState();
    useEffect(()=>{
        if (!portalWrapper) {
            const newWrapper = document.createElement('div');
            /**
             * Preventing performance issues by not appending the children
             * to `document.body` directly. Appending visible dom nodes directly to `document.body`
             * causes `Layout Thrashing` (writing and reading at the same time) which leads to performance issues.
             * Https://atfzl.com/don-t-attach-tooltips-to-document-body.
             */ document.body.appendChild(newWrapper);
            setPortalWrapper(newWrapper);
        } else {
            return ()=>{
                if (document.body.contains(portalWrapper)) document.body.removeChild(portalWrapper);
            };
        }
    }, [
        portalWrapper
    ]);
    return jsx(Fragment, {
        children: portalWrapper ? /*#__PURE__*/ createPortal(children, portalWrapper) : null
    });
};

export { Portal };
//# sourceMappingURL=Portal.es.js.map
